import { render, staticRenderFns } from "./_navbar.vue?vue&type=template&id=99b68a20&scoped=true"
import script from "./_navbar.vue?vue&type=script&lang=js"
export * from "./_navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b68a20",
  null
  
)

export default component.exports